import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20soft%20warm%20beige%20cream%20and%20terracotta%20tones%20featuring%20subtle%20geometric%20grid%20patterns%20reminiscent%20of%20spreadsheets%2C%20minimalist%20aesthetic%2C%20gentle%20diffused%20lighting%2C%20elegant%20editorial%20style%20with%20organic%20textures%20floating%20shapes%20and%20clean%20composition%2C%20soft%20gradient%20background%20with%20delicate%20linear%20elements&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt="CSSBuy Spreadsheet background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65" />
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 drop-shadow-lg">
            The Ultimate <strong className="text-white">CSSBuy Spreadsheet</strong> Library
          </h1>
          <p className="text-base md:text-lg text-white/90 max-w-xl mx-auto mb-8 leading-relaxed drop-shadow-md">
            Discover curated spreadsheet collections, shopping guides, and expert recommendations. Find the best sneakers, hoodies, jackets, and accessories — all in one place.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-label text-sm font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
              CSSBuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white border border-white/40 font-label text-sm font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center"></i>
              Buy It Now
            </a>
          </div>
          <div className="mt-8 pb-2">
            <Link
              to="/cssbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
              Read the Complete CSSBuy Spreadsheet Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}